<template>
  <modal :show="showModal"
         showClose
         modal-classes="modal-dialog-centered modal-lg"
         @close="close">
    <template slot="header">
      <h4 class="modal-title">
        {{ $t('notificationConfigs.update.titleText') }}
      </h4>
    </template>
    <template>
      <div class="text-center text-muted mb-4">
        <small>{{ $t('notificationConfigs.update.helpText') }}</small>
      </div>
      <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
        <!-- TODO: add error translation -->
        {{ getActionErrorDetails }}
      </base-alert>
      <form role="form" @submit.prevent="validate()">
        <!-- select notification type -->
        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('notificationConfigs.form.plugin') }}</label>
          <div class="col-md-9">
            <div class="form-group">
              <base-input :value="formDetails.plugin" disabled=""/>
            </div>
          </div>
        </div>

        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('notificationConfigs.form.eventTypes') }}</label>
          <div class="col-md-9">
            <div class="form-group">
              <el-select
                name="events"
                multiple
                class="select-primary"
                v-model="formDetails.events"
                :placeholder="$t('notificationConfigs.form.eventTypesPlaceholder')">
                <el-option
                  v-for="option in notificationTypes"
                  class="select-info"
                  :value="option"
                  :label="option"
                  :key="option"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>

        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('notificationConfigs.form.webhookUrl') }}</label>
          <div class="col-md-9">
            <base-input
              name="webhookUrl"
              v-validate="modelValidations.required_url"
              :error="getError('webhookUrl')"
              v-model="formDetails.webhookUrl">
            </base-input>
          </div>
        </div>

        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('notificationConfigs.form.environment') }}</label>
          <div class="col-md-9">
            <base-input
              v-model="formDetails.environment">
            </base-input>
          </div>
        </div>

        <div class="row" v-if="formDetails.plugin === 'discord'">
          <label class="col-sm-3 col-form-label">{{ $t('notificationConfigs.form.discord_error_message') }}</label>
          <div class="col-md-9">
            <base-input
              v-model="formDetails.discord_error_message">
            </base-input>
          </div>
        </div>

        <div class="text-center">
          <base-button
            type="info"
            :loading="updating"
            class="my-4"
            native-type="submit"
          >{{ $t('notificationConfigs.update.actionBtnLabel') }}
          </base-button>
        </div>
      </form>
    </template>
  </modal>
</template>


<script>
  import {BaseAlert, Modal} from 'src/components';
  import {Option, Select} from 'element-ui';
  import {mapActions, mapState} from "vuex";

  export default {
    name: 'edit-notification-config-dialog',
    components: {
      [Option.name]: Option,
      [Select.name]: Select,
      Modal,
      BaseAlert
    },
    props: {
      notificationTypes: {
        type: Array,
        required: true
      },
      formDetails: {
        type: Object,
        required: true
      },
      show: {
        type: Boolean,
        required: true
      },
    },
    data() {
      return {
        alert: false,
        modelValidations: {
          required: {
            required: true
          },
        },
      }
    },

    computed: {
      ...mapState({
        updating: state => state.notification_config.updating,
        error: state => state.notification_config.error,
      }),
      getActionErrorDetails() {
        return this.error ? this.error.bodyText : null;
      },
      showModal() {
        return this.show == true
      }
    },
    methods: {
      ...mapActions(['UpdateNotificationConfig', 'LoadNotificationConfigs']),
      close: function () {
        this.$emit('close');
        this.resetForm();
      },
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate: function () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.update()
          }
        });
      },
      update: function () {
        let payload = {
          id: this.formDetails.id,
          events: this.formDetails.events,
          plugin: this.formDetails.plugin,
          disabled: this.formDetails.disabled,
          configuration: {
            webhook_url: this.formDetails.webhookUrl,
            environment: this.formDetails.environment
          }
        };

        if (this.formDetails.plugin === 'discord') {
          payload.configuration.discord_error_message = this.formDetails.discord_error_message
        }

        this.UpdateNotificationConfig(payload).then(() => {
          if (this.error != null) {
            this.alert = true
            // got error, don't reset form
          } else {
            this.LoadNotificationConfigs();
            this.close();
            this.$notify({
              type: 'success',
              message: this.$t('notificationConfigs.update.updatedNotification', this.formDetails),
              icon: 'tim-icons icon-alert-circle-exc'
            })
          }
        });
      },
      resetForm: function () {
        // resetting alerts
        this.alert = false;

        // reset validation errors
        this.$validator.reset()
      }
    }
  }
</script>
